import isEqual from 'lodash.isequal';
import { Basket, BasketItem, Category } from 'menus/interfaces';
import {
  UPDATE_BASKET,
  REMOVE_ITEM,
  UPDATE_ITEM_REVIEW,
  ADD_ITEM,
  UPDATE_SOCKET_BASKET,
  BasketAction,
} from './basket-actions';
import { calculateTotals, getItemWithPrice, addKeys } from './basket-utils';

const mapItemForComparison = (item) => ({
  id: item.id,
  selectedAllergens: item.selectedAllergens,
  selectedAddOns: item.selectedAddOns,
  selectedRemovals: item.selectedRemovals,
  price: item.price,
  discountOption: item.discountOption,
});

const sortByCategory = (newItemCategories: Category[]) => (a, b) => {
  const getSortValue = (item) =>
    newItemCategories.find((category) => category.name === item.category)?.sort || 0;

  return getSortValue(a) - getSortValue(b);
};

export default (state: Basket, action: BasketAction): Basket => {
  switch (action.type) {
    case ADD_ITEM: {
      const newItem = action.payload;
      const { itemList } = state;

      let shouldAddAsNewItem = true;

      if (newItem.isSetMenu) {
        newItem.items.sort(sortByCategory(newItem.categories));
      }

      let newItemList: BasketItem[] = itemList.map((item) => {
        if (item.isSetMenu === newItem.isSetMenu) {
          let basketItem;
          let itemToAdd;

          if (newItem.isSetMenu) {
            basketItem = item.items.map(mapItemForComparison);
            itemToAdd = newItem.items.map(mapItemForComparison);
          } else {
            basketItem = mapItemForComparison(item);
            itemToAdd = mapItemForComparison(newItem);
          }

          if (isEqual(basketItem, itemToAdd)) {
            shouldAddAsNewItem = false;

            return getItemWithPrice({
              ...item,
              quantity: item.quantity + newItem.quantity,
            });
          }
        }
        return item;
      });

      if (shouldAddAsNewItem) {
        const itemWithPrice: BasketItem = getItemWithPrice(newItem);

        newItemList = [...newItemList, itemWithPrice];
      }

      const newItemListWithKeys: BasketItem[] = newItemList.map(addKeys);

      return {
        itemList: newItemListWithKeys,
        ...calculateTotals(newItemListWithKeys),
      };
    }
    case REMOVE_ITEM: {
      const item = action.payload;
      const { itemList } = state;

      const itemIndex = item.key!;
      itemList.splice(itemIndex, 1);
      const newItemList = itemList.map((basketitem, idx) => ({
        ...basketitem,
        key: idx,
      }));
      return {
        itemList: newItemList,
        ...calculateTotals(newItemList),
      };
    }
    case UPDATE_ITEM_REVIEW: {
      const item = action.payload;
      const { itemList } = state;

      const itemIndex = item.key!;

      const itemWithPrice = getItemWithPrice({
        ...itemList[itemIndex],
        ...item,
      });

      itemList.splice(itemIndex, 1, itemWithPrice);

      const newItemList = itemList.map(addKeys);

      return {
        itemList: newItemList,
        ...calculateTotals(newItemList),
      };
    }
    case UPDATE_BASKET: {
      const basket = action.payload;
      const { updated, ...remoteBasket } = basket;
      return {
        ...remoteBasket,
        updated: false,
      };
    }
    case UPDATE_SOCKET_BASKET: {
      return { ...state, updated: true };
    }
    default: {
      return state;
    }
  }
};
